import React, { useState } from 'react'
import { FormFooterButton, InputCss } from '../../../helper/CommonFunction';
import { ApiHandler } from '../../../helper/ApiHandler';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ModalLarge } from '../../../components/ModalComponets';

const AddEditBudget = ({ isOpen, onClose, setResetSearch, title }) => {
    const token = useSelector(state => state.user.userToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const initialState = {
        startPrice: '',
        endPrice: '',
    };

    const [formData, setFormData] = useState(initialState);

    const { startPrice, endPrice } = formData;

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleClose = () => {
        setFormData(initialState);
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!startPrice || !endPrice) {
            toast.error("Please enter both start and end prices.");
            return;
        }
        if (parseInt(startPrice) > parseInt(endPrice)) {
            toast.error("Start price should be less than end price.");
            return;
        }

        const body = {
            start_amount: startPrice,
            end_amount: endPrice
        }

        try {
            const result = await ApiHandler('/add_bike_budget.php', 'POST', body, token, dispatch, navigate)
            if (result.data.status === "1") {
                toast.success(result?.data.msg)
                handleClose();
                setResetSearch(true);
            } else {
                toast.error(result?.data.msg)
            }
        } catch (error) {
            handleClose();
        }
    };

    return (
        <ModalLarge isOpen={isOpen} title={title} onClose={handleClose} modalWidth={false}>
            <form onSubmit={handleSubmit} className="p-4">
                <div className='grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-4'>
                    <div>
                        <label
                            htmlFor="userId"
                            className="block text-[#222] font-semibold mb-1"
                        >
                            Start Price
                        </label>
                        <input
                            type="number"
                            name="startPrice"
                            value={startPrice}
                            placeholder='Please Enter a Condition'
                            onChange={handleInputChange}
                            required
                            className={`${InputCss}`}
                        />
                    </div>
                    <div>
                        <label
                            htmlFor="userId"
                            className="block text-[#222] font-semibold mb-1"
                        >
                            End Price
                        </label>
                        <input
                            type="number"
                            name="endPrice"
                            value={endPrice}
                            placeholder='Please Enter a Condition'
                            onChange={handleInputChange}
                            required
                            className={`${InputCss}`}
                        />
                    </div>
                </div>

                <FormFooterButton onClick={handleClose} />
            </form>
        </ModalLarge>
    )
}

export default AddEditBudget;
